import { render } from "./ClientList.vue?vue&type=template&id=0d5acb05&scoped=true"
import script from "./ClientList.vue?vue&type=script&lang=js"
export * from "./ClientList.vue?vue&type=script&lang=js"

import "./ClientList.vue?vue&type=style&index=0&id=0d5acb05&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aryav\\Desktop\\Don't touch this file\\Talreq\\talreq\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d5acb05"]])

export default __exports__